import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Typography } from '../Typography';

export const ToggleContainer = styled(FlexibleDiv)`
  background-color: ${({ theme }) => theme.colors.text.tertiary};
  padding: 3px;
  border-radius: 14px;
  height: 50px;
  gap: 10px;
  cursor: pointer;
`;

export const OptionText = styled(Typography)<{ $isSelected: boolean }>`
  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      color: ${({ theme }) => theme.colors.text.white};
    `};
  transition: color 0.3s ease;
`;

export const ToggleOption = styled.div<{ $isSelected: boolean }>`
  border-radius: 14px;
  padding: 13px 15px;
  cursor: pointer;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: ${({ theme: { colors } }) => colors.background.primary};
    `};

  @media (hover: hover) {
    &:hover {
      ${OptionText} {
        color: ${({ theme }) => theme.colors.systemColors.blue};
      }
    }
  }
`;
